// CÂND SE REÎNCADREAZĂ DESENUL — și, mai ales, când nu.
//
// Reîncadrarea rescrie zoom-ul, panoramarea și rotirea, adică tot ce a așezat
// omul cu mâna. De-aia lista celor care o declanșează e scrisă aici, explicit,
// ca funcție pură: în dependențele unui `useEffect` e prea ușor să strecori o
// valoare care se schimbă la fiecare click, iar greșeala se vede abia din
// pagină.
//
// S-a întâmplat de două ori. Întâi cu SELECȚIA — fiecare click reîncadra tot,
// și de acolo venea „mă dă zoom out când dau click". Apoi cu ETAJUL: etajele
// unei clădiri sunt stivuite, stau în același loc din lume, deci schimbând
// nivelul nu se mută nimic și n-are ce reîncadra — dar cadrul sărea oricum, iar
// cine mărise pe un apartament ca să-l compare cu cel de deasupra îl pierdea
// fix când voia să compare. A treia oară a fost chiar reparația: cheia primise
// `arhActiv?.id`, adică IDUL PLANȘEULUI ACTIV, care se schimbă cu etajul — deci
// n-a reparat nimic.
//
// De aici regula: intră în cheie CE se încadrează, nu ce se vede din el. Nivelul
// nu e un parametru al funcției ăsteia, și nu are voie să devină.

export interface CeSeIncadreaza {
  /** Soluția deschisă. */
  solutie: string;
  /** Corpul ales, sau «toate». */
  corp: string | null;
  /** Planșa de situație în locul nivelurilor. */
  situatie: boolean;
  /** Macheta de situație în locul desenului. */
  machetaSit: boolean;
  /** Dacă e un planșeu de arhitectură dedesubt — schimbă plafonul de mărire,
   *  nu identitatea cadrului. BOOLEAN, nu idul planșeului: idul se schimbă cu
   *  etajul, și atunci cheia n-ar mai însemna nimic. */
  areArh: boolean;
  /** Previzualizarea compactă, unde cadrul chiar urmează selecția. */
  compact: boolean;
  /** Selecția — numai în compact, altfel șir gol. */
  selectie: string;
  /** Ținta venită din verificări, prin cheia ei stabilă. */
  tinta: string;
  /** Fereastra. O redimensionare chiar cere alt cadru. */
  dim: { w: number; h: number } | null;
}

export function cheieDeCadru(x: CeSeIncadreaza): string {
  return [
    x.solutie, x.corp ?? "", x.situatie, x.machetaSit, x.areArh, x.compact,
    x.selectie, x.tinta,
    x.dim ? `${Math.round(x.dim.w)}x${Math.round(x.dim.h)}` : "",
  ].join("|");
}
